import { ActionIcon, Tooltip } from "@mantine/core";
import { Settings2 } from "lucide-react";

import type { Composer } from "../composer/use-composer";
import classes from "./advanced.module.css";

export interface AdvancedSettingsProps {
  c: Composer;
  open: boolean;
  onToggle: () => void;
}

/**
 * Live's "Advanced settings" button in the video composer's footer (#231): it opens the side
 * panel of the type's advanced settings, shows itself pressed while it is open, and is disabled
 * where the type takes none.
 */
export function AdvancedSettings({ c, open, onToggle }: AdvancedSettingsProps) {
  const none = !c.advancedOffered;
  return (
    <Tooltip label="Advanced settings" withArrow>
      {/* A disabled button takes no hover, so the tooltip hangs from a wrapper, as live's. */}
      <span className={classes.toggle}>
        <ActionIcon
          variant={open && !none ? "light" : "subtle"}
          size="md"
          radius={8}
          aria-label="Advanced settings"
          aria-expanded={open && !none}
          disabled={none}
          onClick={onToggle}
        >
          <Settings2 size={20} strokeWidth={1.5} aria-hidden />
        </ActionIcon>
      </span>
    </Tooltip>
  );
}
